import { createStash } from "@latticexyz/stash/internal";
import { stashConfig } from "../common";

export const stash = createStash(stashConfig);
